import { render, staticRenderFns } from "./project-construction.vue?vue&type=template&id=aabe9a42&scoped=true"
import script from "./project-construction.vue?vue&type=script&lang=js"
export * from "./project-construction.vue?vue&type=script&lang=js"
import style0 from "./project-construction.vue?vue&type=style&index=0&id=aabe9a42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aabe9a42",
  null
  
)

export default component.exports